<template>
  <div class="module">
    <div class="module__title"></div>
    <div class="module__content">
      <div class="icon-list">
        <div class="icon-item">
          <div class="icon icon-wechat" @click="openCode('wechat')"></div>
          <div class="name">官方微信</div>
        </div>
        <div class="icon-item">
          <div class="icon icon-weibo" @click="openLink('weibo')"></div>
          <div class="name">官方微博</div>
        </div>
        <div class="icon-item">
          <div class="icon icon-taptap" @click="openLink('taptap')"></div>
          <div class="name">TapTap</div>
        </div>
        <div class="icon-item">
          <div class="icon icon-hykb" @click="openLink('hykb')"></div>
          <div class="name">好游快爆</div>
        </div>
        <div class="icon-item">
          <div class="icon icon-bilibili" @click="openLink('bilibili')"></div>
          <div class="name">哔哩哔哩</div>
        </div>
        <div class="icon-item">
          <div class="icon icon-xhs" @click="openLink('xhs')"></div>
          <div class="name">小红书</div>
        </div>
      </div>
    </div>
    <mobile-dialog :title="dialogTitle" :visible.sync="dialogVisible" @confirm="handleDialogConfirm">
      <template #content>
        <div class="code-box">
          <div class="code"></div>
          <div class="description">扫码关注微信公众号</div>
        </div>
      </template>
    </mobile-dialog>
  </div>
</template>

<script>
import MobileDialog from '@/views/mobile/components/dialog/Index.vue'

import socialMixins from '@/mixins/home/socialMixins.js'

export default {
  name: 'MobileHomeSocial',
  mixins: [socialMixins],
  components: {
    MobileDialog,
  },
}
</script>

<style lang="scss" scoped>
.module {
  height: 108.933333vw;

  &__title {
    background-position: center -139.733333vw;
  }

  &__content {
    width: 100%;
  }
}

.icon-list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 7.333333vw auto 0;
  width: 64vw;

  .icon-item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5.333333vw;
    width: 18.133333vw;
    height: 25.2vw;

    .icon {
      width: 18.133333vw;
      height: 18.133333vw;
      background: url('~@/assets/img/common/social_icon.png') no-repeat;
      background-size: 54.4vw 36.266666vw;
      border-radius: 50%;

      &-wechat {
        background-position: 0 0;
      }
      &-weibo {
        background-position: -18.133333vw 0;
      }
      &-bilibili {
        background-position: -36.266666vw 0;
      }
      &-taptap {
        background-position: 0 -18.133333vw;
      }
      &-hykb {
        background-position: -18.133333vw -18.133333vw;
      }
      &-xhs {
        background-position: -36.266666vw -18.133333vw;
      }
    }

    .name {
      font-size: 3.296666vw;
      font-family: Noto Serif SC;
      font-weight: bold;
      color: #584c45;
    }
  }
}

.code-box {
  margin: 5vw auto 10vw;
  width: 45vw;
  height: 52vw;
  background: #fff;
  border: .133333vw solid #e5d6cb;

  .code {
    margin: 0 auto;
    width: 44vw;
    height: 44vw;
    background: url('~@/assets/img/common/wechat.jpg') no-repeat;
    background-size: 100%;
  }

  .description {
    text-align: center;
    line-height: 4vw;
    font-size: 4vw;
    color: #000;
  }
}
</style>